/**
 * Coerce catalog `category` (string, slug object, or CMS-shaped object) to a lowercase slug string.
 * Used for Sanity docs, legacy items, and filter chip matching.
 * @param {unknown} raw
 * @returns {string|undefined}
 */
export function normalizeItemCategory(raw) {
  if (raw == null || raw === '') return undefined
  if (typeof raw === 'string') {
    const s = raw.trim().toLowerCase()
    return s || undefined
  }
  if (Array.isArray(raw)) {
    for (const el of raw) {
      const n = normalizeItemCategory(el)
      if (n) return n
    }
    return undefined
  }
  if (typeof raw === 'object') {
    if (raw.current != null) return normalizeItemCategory(raw.current)
    if (raw.slug != null) return normalizeItemCategory(raw.slug)
    if (typeof raw.slug === 'object' && raw.slug?.current != null) {
      return normalizeItemCategory(raw.slug.current)
    }
  }
  return undefined
}
